import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import {
  CoverExtra,
  DeliveryGuaranteeExtra,
  ExtendedBaseCoverExtra,
  PrintInStoreExtra,
  SignatureExtra,
  SmsExtra
} from '../../../ExtrasHelper';
import { Actions } from '../../rules/Actions';
import { SmartSendProvider } from '~/lib/consts/providers';

export function getItemValueForAction(item: SmartSendItemApiModel, action: string): string {
  switch (action) {
    case Actions.Item_Weight:
      return String(item.PackageDimensions.Weight);

    case Actions.Item_Height:
      return String(item.PackageDimensions.Height);

    case Actions.Item_Width:
      return String(item.PackageDimensions.Width);

    case Actions.Item_Length:
      return String(item.PackageDimensions.Length);

    case Actions.Extra_Sms:
      return item.Extras.find((e) => e.Id === SmsExtra) ? String(true) : '';

    case Actions.Extra_Cover:
      return item.Extras.find((e) => e.Id === CoverExtra) ? String(true) : '';

    case Actions.Extra_DeliveryGuarantee:
      return item.Extras.find((e) => e.Id === DeliveryGuaranteeExtra) ? String(true) : '';

    case Actions.Extra_ExtendedBaseCover:
      return item.Extras.find((e) => e.Id === ExtendedBaseCoverExtra) ? String(true) : '';

    case Actions.Extra_PrintInStore:
      return item.Extras.find((e) => e.Id === PrintInStoreExtra) ? String(true) : '';

    case Actions.Extra_Signature:
      return item.Extras.find((e) => e.Id === SignatureExtra) ? String(true) : '';

    case Actions.Item_TariffCode:
      return item.MarketplaceOrderLines.map((x) => x.Product?.TariffCode).filter((x) => !!x)[0];

    case Actions.Item_Service:
      return item.Service.Provider === SmartSendProvider ? item.Service.Id : '';

    case Actions.Item_CourierService:
      return item.Service.Provider === SmartSendProvider
        ? ''
        : `${item.Service.Provider}|${item.Service.AccountId}|${item.Service.Id}`;

    default:
      return '';
  }
}
